<div #loadNextPageElement>
  <button
    id="pagination-next-btn"
    class="btn btn-block bg-light border-0 mt-4"
    (click)="paginate()"
    [title]="'load.next' | translate"
  >
    @if (loadingPage) {
      <i class="spinner-border text-primary spinner-border-sm me-2" role="status"> </i>
    }
    {{ loadingPage ? ('loading' | translate) : ('load.next' | translate) }}
  </button>
</div>
